
import RequestAbstract from "./RequestAbstract";

/**
 * Created by viclight on 03.03.2024.
 */
export default class Employees extends RequestAbstract {

    /*
    get cacheInterval() {
        return 7;
    }
    */


    get link() {
        return this.links.employees;
    }

    async getAll() {

        return await this.getAllFiltered([[{ field: "isActive", op: "=", value: true }]], this.getSortField(["lname"]));
    }

    async getEmployeeById(id) {
        const { data } = await this.getAllFiltered([[{ field: "id", op: "=", value: id }]]);
        if (data.length > 0)
            return data[0];

        return null;
    }

    async addEmployee(info) {
        return await this.post(this.link + "/add", info);
    }

}
